import { ModelTableView } from '@/assets/js/ModelView'
import * as C from '../list'

const asset = new ModelTableView([
	C.name,
	C.registration,
	C.description,
	C.phone,
	C.email,
	C.trackerUrl,
	C.remarks,
	C.state
]);

asset.visibleProperties([ "name", "registration", "description", "trackerUrl" ]);
asset.sortBy("name");

export default asset;



// WEBPACK FOOTER //
// ./src/services/components/views/asset.js